/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/AwardsMenu',['pixi', 'absolute', 'lodash', 'MenuUI/MenuTab', 'gameconfig', 'MenuUI/Menu',
		'absolute/screenmetrics',
		'MenuUI/ChallengeTile',
		'Solitaire/SolitaireGameMode',
		'MenuUI/MonthlyAwardsTile',
		'MenuUI/SideBar',
		'MenuUI/ControlFocusManager',
		'Solitaire/MvvmStructure/Service/SolitaireDailyChallengeService',
		'Managers/ScaleManager', 'Managers/ScrollManager'
	],
	function (PIXI, Absolute, _, MenuTab, GameConfig, Menu, ScreenMetrics, ChallengeTile, SolitaireGameMode,
	          MonthlyAwardsTile, SideBar, ControlFocusManager,
	          SolitaireDailyChallengeService, ScaleManager, ScrollManager) {

		var AwardsMenu = function (ui, game, year) {

			if (this.scrollable) this.removeChild(this.scrollable);
		};

		AwardsMenu.prototype = Object.create(Absolute.Screen.prototype);

		AwardsMenu.prototype.loadArtAssets = function (onSuccess, onError) {
			var levelLoader = new Absolute.Loader(),
				atlases = [{name: 'aw_menu'}];
			levelLoader.loadAtlases(atlases,
				function (percentComplete) {
					Absolute.Debug.log('loading awards menu assets ', percentComplete);
				}.bind(this),
				onSuccess,
				onError);
		};

		AwardsMenu.prototype.initialize = function (ui, year, game) {

			Absolute.Screen.call(this);

			this.ui = ui;
			this.game = game;
			this.year = year;

			this.controlFocusManager = new ControlFocusManager();

			var background = PIXI.Sprite.fromFrame('win10_MS_bg.png');
			this.background.addChild(background);

			this.clickHandler = this.handleGameInput.bind(this);

			window.addEventListener('click', this.clickHandler);
			ScaleManager.addElement(this, {scaleChangeSource: 'Full'});
		};

		AwardsMenu.prototype.initTouchInterface = function () {
			// Dragging and panning
			this.lastDeltaY = 0;
			this.startY = 0;
			var hitArea = new PIXI.Rectangle(0, 0, Absolute.Coords.x(1920), Absolute.Coords.y(1080));
			this.touchContainer = new PIXI.DisplayObjectContainer();
			this.touchContainer.interactive = true;
			this.touchContainer.hitArea = hitArea;
			this.touchContainer.addChild(this.scrollable);
			this.touchContainer.mousedown = this.touchContainer.touchstart = this.handleDragStart.bind(this);
			this.touchContainer.mousemove = this.touchContainer.touchmove = this.handleDrag.bind(this);
			this.touchContainer.mouseupoutside = this.touchContainer.mouseup = this.touchContainer.touchend = this.touchContainer.touchendoutside = this.handleDragEnd.bind(this);
			this.addChild(this.touchContainer);

		};

		AwardsMenu.prototype.initSidebar = function () {
			this.sidebar = new SideBar({
				availableHeight: 200, partialHeight: 100,
				onScrollUpdate: function (p) {
				}.bind(this)
			});
			this.addChild(this.sidebar);
			this.sidebar.position.set(Absolute.Coords.x(1900), Absolute.Coords.y(67));
			this.updateSidebar();
		};

		AwardsMenu.prototype.updateSidebar = function () {
			if (!this.sidebar || !this.scrollable) return;
			var height = Absolute.Coords.y(66),
				headerHeight = ((height / ScaleManager.scaleFactorY));
			var screenScaleX = ScaleManager.width / Absolute.Coords.x(1920),
				screenScaleY = ScaleManager.height / Absolute.Coords.y(1080);
			this.sidebar.scale.set(1, 1);
			this.sidebar.width = this.sidebar.width / screenScaleX;
			this.sidebar.height = this.sidebar.height / screenScaleY;
			this.sidebar.y = headerHeight;
			this.sidebar.x = Absolute.Coords.x(1900) - (this.sidebar.width - (this.sidebar.width * screenScaleX));
			var availableHeight, partialHeight, posY;
			availableHeight = this.scrollableFakeHeight;
			partialHeight = Absolute.Coords.x(1080);
			posY = availableHeight - Absolute.Coords.y(1080);
			this.sidebar.resetDimensions(availableHeight, partialHeight, function (p) {
				var y = -Math.abs(posY) * p / 100;
				this.scrollable.y = y;
				if (this.scrollable.y > 0) this.scrollable.y = 0;
				if (Math.abs(this.scrollable.y) > posY) {
					this.scrollable.y = -posY;
				}
			}.bind(this), (ScaleManager.height - 65));
			this.sidebar.visible = (partialHeight < availableHeight);
			this.sidebar.updateHandleByPercent(100 * Math.abs(this.scrollable.y) / Math.abs(posY));
		};


		AwardsMenu.prototype.onShow = function () {
			this.ui.showLoadingScreen();
			ScrollManager.add(this, this.doScroll, this);
			if (!this.artInitialized) {
				this.loadArtAssets(
					function () {
						this.artInitialized = true;
						this.completeInit();
					}.bind(this),
					function () {
					}
				);
			} else {
				this.completeInit();
			}

		};

		AwardsMenu.prototype.handleResize = function () {
			if (!this.scrollable) return;
			this.container.y = (this.game.menuBar.menuButton.y + this.game.menuBar.menuButton.height)
				* (this.container.width * this.container.children[0].pageGenerator.cardScale / ScaleManager.width) * (ScaleManager.height / Absolute.Coords.y(985));
			this.updatePagesPositions();
			this.updateSidebar();
			this.tiles.forEach(function (tile) {
				tile.resizeInfoBoxContainer();
			}.bind(this));
			this.scrollable.height = (this.currentWidth / this.container.width) * (Absolute.Coords.y(985) / ScaleManager.height)
				* (ScaleManager.width / Absolute.Coords.x(1840)) * this.currentHeight;
			this.scrollable.width = this.currentWidth;
			this.scrollableFakeHeight = this.scrollable.height + Absolute.Coords.x(150) + this.tiles[0].infoBoxContainer.height;
			if ((this.scrollable.y < 0) && ((this.scrollableFakeHeight + this.scrollable.y) < Absolute.Coords.y(1080))) {
				this.scrollable.y = Absolute.Coords.y(1080) - this.scrollableFakeHeight;
			}
		};

		AwardsMenu.prototype.updatePagesPositions = function () {
			var prevChild, scale = (this.container.width / this.currentWidth),
				xPos = Absolute.Coords.x(50), yGap = Absolute.Coords.y(70) * scale,
				startY = Absolute.Coords.y(90) * scale;
			this.currentHeight = Absolute.Coords.y(21);
			this.container.children.forEach(function (c) {
				c.x = xPos;
				c.y = prevChild ? prevChild.y + prevChild.height + yGap : startY;
				this.currentHeight += c.height + (prevChild ? yGap : 0);
				prevChild = c;
			}.bind(this));
		};

		AwardsMenu.prototype.onHide = function () {
			this.resetControlManager();
			this.controlFocusManager.removeAllControls();
			ScrollManager.remove(this);
			this.removeChild(this.sidebar);
		};

		AwardsMenu.prototype.completeInit = function () {
			if (this.menu) {
				this.menu.onShow();
			}
			this.initData();
			this.addChild(this.game.menuBar);
			this.ui.hideLoadingScreen();
			this.game.menuBar.onShow(true, true, false, Absolute.StringManager('titles.dailyChallengeBadges'));
			this.handleResize();
			this.initControls();
			this.handleResize();
		};

		AwardsMenu.prototype.initControls = function () {
			this.controlFocusManager.addControl(this.game.menuBar.controlGroup[0], false, 'LeftButtons');
			this.controlFocusManager.addControl(this.game.menuBar.controlGroup[1], false, 'LeftButtons');
			if (this.game.menuBar.fullScreenEnabled) {
				this.controlFocusManager.addControl(this.game.menuBar.controlGroup[3], false, 'RightButtons');
			}
			for (var i = 0; i < this.badges.length; i++) {
				this.controlFocusManager.addControl(this.badges[i], false, this.badges[i].getKey());
			}
		};

		AwardsMenu.prototype.initData = function () {
			if (this.menu) {
				this.removeChild(this.menu);
			}
			this.badges = [];
			this.tiles = [];
			var data = SolitaireDailyChallengeService.GetChallengesData();
			var tileConfig = {
				background: {
					width: Absolute.Coords.x(565),
					height: Absolute.Coords.y(385)
				}
			};
			var years = [];
			this.currentWidth = Absolute.Coords.x(1850);
			this.scrollable = new PIXI.DisplayObjectContainer();
			this.container = new PIXI.DisplayObjectContainer();
			for (var year in data) {
				if (this.year && this.year !== year) continue;
				var first = !years[years.length - 1];
				var tiles = [];
				for (var month in data[year]) {
					var tile = new MonthlyAwardsTile(tileConfig, data[year][month], year, month, this);
					tiles.push(tile);
					this.tiles.push(tile);
				}
				this.badges = this.badges.concat(tiles);
				var menu = new Menu(_.extend({
					'tiles': tiles,
					'label': '20' + year + ' ' + Absolute.StringManager('DailyChallenge.badges'),
					'tilePaddingX': Absolute.Coords.x(30),
					'keepOneLine': true,
					'maxColNum': 4
				}, ScaleManager.scaleParams['MenuConfigs']['AwardsMenuConfigs']));
				menu.x = Absolute.Coords.x(90);
				menu.y = !first ? years[years.length - 1].height + Absolute.Coords.y(200) : Absolute.Coords.y(170);
				years.push(menu);
				this.container.addChild(menu);
			}
			this.scrollable.addChild(this.container);
			this.addChild(this.scrollable);
			this.scrollable.width = this.currentWidth;
			this.initTouchInterface();
			if (!this.sidebar) this.initSidebar();
			this.addChild(this.sidebar);
			this.scrollTo(0);
		};

		AwardsMenu.prototype.handleDragStart = function (data) {
			this.dragging = true;
			this.lastDeltaY = 0;
			this.startY = data.getLocalPosition(this.parent).y;
			this.enableButtons(false);
		};

		AwardsMenu.prototype.handleDrag = function (data) {

			if (!this.dragging) {
				return;
			}

			var pos = data.getLocalPosition(this.parent),
				delta = pos.y - this.startY;

			this.scrollTo(this.scrollable.y + ((delta - this.lastDeltaY) * ScreenMetrics.devicePixelRatio));

			this.lastDeltaY = delta;
		};

		AwardsMenu.prototype.handleDragEnd = function (data) {

			if (!this.dragging) {
				return;
			}
			this.dragging = false;
		};

		AwardsMenu.prototype.enableButtons = function (enable) {

			var i, l;

			for (i = 0, l = this.scrollable.children.length; i < l; i++) {
				this.scrollable.children[i].interactive = enable;
			}

		};

		AwardsMenu.prototype.doScroll = function (e) {
			if (this.scrollableFakeHeight < Absolute.Coords.y(1080)) return;
			var deltaY = 0;
			if (!e) e = window.event;
			if (e.wheelDelta) {
				deltaY = e.wheelDelta / 15;
			} else if (e.detail) {
				deltaY = -e.detail / 3;
			}
			this.scrollTo(this.scrollable.y + (deltaY * 100));
			e.preventDefault();
		};

		AwardsMenu.prototype.handleCommand = function (command, isMouseWheel) {
			if (isMouseWheel) return;
			this.selectSection(command, isMouseWheel);
			switch (command) {
				case 'Right': {
					if (!this.sectionSelected) return;
					this.controlFocusManager.focusNextControl(1);
					break;
				}
				case 'Left': {
					if (!this.sectionSelected) return;
					this.controlFocusManager.focusNextControl(-1);
					break;
				}
				case 'Up': {
					this.controlFocusManager.focusNextControl(-1);
					break;
				}
				case 'Down': {
					this.controlFocusManager.focusNextControl(1);
					break;
				}
				case 'Activate':
					this.controlFocusManager.activateCurrentControl();
					break;
				case 'Unfocus':
					this.controlFocusManager.unfocusCurrentControl();
					break;
			}

		};

		AwardsMenu.prototype.scrollTo = function (y, scroller) {
			if (!this.scrollable) return;
			if (this.scrollableFakeHeight <= Absolute.Coords.y(1080)) {
				this.scrollable.y = 0;
				return;
			}
			this.tiles.forEach(function (t) {
				t.hideInfoBoxContainer(t.infoBoxContainer);
			});
			this.scrollable.y = y;
			if (this.scrollable.y > 0) this.scrollable.y = 0;
			var posY = this.scrollableFakeHeight - Absolute.Coords.y(1080);
			if (Math.abs(this.scrollable.y) > posY) {
				this.scrollable.y = -posY;
			}
			if (this.sidebar) this.sidebar.updateHandleByPercent(100 * Math.abs(this.scrollable.y) / Math.abs(posY));
		};

		AwardsMenu.prototype.selectSection = function (command, isMouseWheel) {
			if (command === 'Tab' || command === 'ShiftTab') {
				this.controlFocusManager.focusCurrentControl();
				this.sectionSelected = true;
				if (command === 'Tab') {
					if (
						this.controlFocusManager.currentFocusGroup ===
						this.controlFocusManager.getLastControl().focusGroup
					) {
						this.controlFocusManager.setFocusGroup('LeftButtons');
					} else {
						this.controlFocusManager.nextFocusGroup();
					}
				} else if (command === 'ShiftTab') {
					if (
						this.controlFocusManager.currentFocusGroup ===
						this.controlFocusManager.getFirstControl().focusGroup
					) {
						this.controlFocusManager.setFocusGroup(this.badges[this.badges.length - 1].getKey());
					} else {
						this.controlFocusManager.prevFocusGroup();
					}
				}
			}
		};

		AwardsMenu.prototype.handleGameInput = function () {
			this.resetControlManager();
		};

		AwardsMenu.prototype.resetControlManager = function () {
			this.controlFocusManager.unfocusCurrentControl();
		};

		return AwardsMenu;

	});

